import { AprilTagFamily } from 'apriltag';
import tag36h11 from 'apriltag/families/36h11.json';

const aprilTagFamily = new AprilTagFamily(tag36h11);

export function getAprilTagImageSrc(tagId: number): string | null {
  if (tagId < 0 || tagId >= aprilTagFamily.codes.length) {
    return null;
  }

  // aprilTagFamily.render() always wraps the tag in a 1-cell white quiet
  // zone outside the black border, with no option to configure or omit it.
  // We crop that ring here purely to reduce whitespace in the generated
  // image; the black border itself (which starts one cell in) is untouched.
  // Note: this trims the tag's standard print-spec quiet zone, which can
  // reduce detection reliability if this image is printed and read by a
  // camera. Trade-off accepted deliberately to reduce whitespace; revisit
  // if physical/camera-based scanning of these generated codes is added.
  const rawBitmap = aprilTagFamily.render(tagId);
  const bitmap = rawBitmap.slice(1, -1).map((row) => row.slice(1, -1));
  const size = bitmap.length;
  const blackCells = bitmap
    .map((row, y) => row.map((cell, x) => (cell === 'b' ? `M${x},${y}h1v1h-1z` : '')).join(''))
    .join('');

  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${size} ${size}" shape-rendering="crispEdges">` +
    `<rect width="${size}" height="${size}" fill="#fff"/>` +
    `<path d="${blackCells}" fill="#000"/>` +
    `</svg>`;

  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}
